import { AppInsights } from 'applicationinsights-js';
import config from '@app/config';

AppInsights.downloadAndSetup({ instrumentationKey: config.appInsights.instrumentationKey });

export default AppInsights;



// WEBPACK FOOTER //
// ./src/appInsights.js